import { useEffect, useState } from "react";
import Select from "react-select";
import API from "@unisearch/helpers/api";
import { selectStyles } from "./select_style.js";
import Skeleton from "@unisearch/common/skeleton/index.jsx";

const CourseFormSelectLevel = ({ levelValue, setLevelValue }) => {
  const [formatedData, setFormatedData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const res = await API.get("/public/course-level");
        if (res.data) {
          setFormatedData(
            res.data.map((item) => ({
              label: item.levelName,
              value: item.slug,
            }))
          );
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const handleSelectChange = (newValue) => {
    if (newValue === null) {
      setLevelValue(null);
    } else {
      setLevelValue(newValue);
    }
  };

  return (
    <>
      {loading ? (
        <>
          <Skeleton height={60} />
        </>
      ) : (
        <Select
          isClearable
          isSearchable
          styles={selectStyles}
          options={formatedData}
          placeholder="Select Study Level"
          onChange={handleSelectChange}
          value={levelValue}
        />
      )}
    </>
  );
};

export default CourseFormSelectLevel;
